import { getLuxPlusSubscriptionItemView, getSubscriptionJoinItemView } from 'checkout/selectors/view/luxPlusSubscription'
import { EmptyArray } from 'lib/array/arrayUtils'
import { buildEarnKey, LUX_LOYALTY_LUX_PLUS_ELIGIBLE_RENEWAL_BONUS_ID } from '@luxuryescapes/lib-lux-loyalty'
import { createSelector } from 'reselect'
import getIsLoyaltyLuxPlusRenewalBonusEnabled from 'loyalty/selectors/getIsLoyaltyLuxPlusRenewalBonusEnabled'
import { getPromoKeyForLoyaltyItem } from 'lib/promo/promoMappers'

const getCheckoutLuxPlusPointsCalculationRequests = createSelector(
  (state: App.State) => getIsLoyaltyLuxPlusRenewalBonusEnabled(state),
  (state: App.State) => state.auth.account.luxPlus.member.subscription.item?.isWithinRenewalGracePeriod,
  (state: App.State) => state.checkout.promo?.loyaltyPointsBonusResultV1,
  (state: App.State) => getLuxPlusSubscriptionItemView(state),
  (state: App.State) => getSubscriptionJoinItemView(state),
  (isLoyaltyLuxPlusRenewalBonusEnabled, isWithinRenewalGracePeriod, loyaltyPointsBonusResultV1, ...luxPlusItems): Array<App.LoyaltyPointsEarnCalculationRequest> => {
    if (luxPlusItems.some(items => !items.hasRequiredData)) return EmptyArray
    const shouldIncludeEarnKey = isLoyaltyLuxPlusRenewalBonusEnabled && !!isWithinRenewalGracePeriod
    return luxPlusItems.flatMap(items => items.data.map((itemView): App.LoyaltyPointsEarnCalculationRequest => {
      const promoKey = getPromoKeyForLoyaltyItem(loyaltyPointsBonusResultV1, { filter: { itemId: itemView.item.itemId } })
      if (!shouldIncludeEarnKey) {
        return {
          price: itemView.totals.price,
          loyaltyProductType: 'lux_plus',
          itemId: itemView.item.itemId,
          offerId: itemView.offerId,
          packageId: '',
          promoKey,
        }
      }

      return {
        price: itemView.totals.price,
        loyaltyProductType: 'lux_plus',
        itemId: itemView.item.itemId,
        earnKey: buildEarnKey([
          ['productType', LUX_LOYALTY_LUX_PLUS_ELIGIBLE_RENEWAL_BONUS_ID],
          ['offerId', itemView.offerId],
        ]),
        promoKey,
        offerId: itemView.offerId,
        packageId: '',
      }
    }))
  },
)

export default getCheckoutLuxPlusPointsCalculationRequests
